import router from '../../router'
import axios from 'axios'
import urls from '../../urls'

export default {
  state: {
    user: {},
    errors: {
      getUserNameError: null
    }
  },
  mutations: {
    GET_USER_INFO_SUCCESS(state, data) {
      state.user = data
      state.errors.getUserNameError = null
    },
    GET_USER_INFO_ERROR(state, error) {
      state.errors.getUserNameError = error
    }
  },
  actions: {
    GET_USER_NAME({ commit }) {
      axios({
        method: 'GET',
        url: urls.GET_NAME_BY_TOKEN_URL
      })
        .then(response => {
          commit('GET_USER_INFO_SUCCESS', response.data)
        })
        .catch(error => {
          commit('GET_USER_INFO_ERROR', error.response)
        })
    },
    SET_LOGOUT({ state }) {
      state.userName = ''
      localStorage.removeItem('SmartId-SessionId')
      router.push({ path: '/' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/userInfo/index.js